import { render, staticRenderFns } from "./migrationpembayaranprk.vue?vue&type=template&id=49580304&scoped=true&"
import script from "./migrationpembayaranprk.vue?vue&type=script&lang=js&"
export * from "./migrationpembayaranprk.vue?vue&type=script&lang=js&"
import style0 from "./migrationpembayaranprk.vue?vue&type=style&index=0&id=49580304&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49580304",
  null
  
)

export default component.exports